<template>
    <div>
        <loader v-if="!product && loading" :loading="true" :fixed="true"></loader>
        <main class="center full" v-if="product">
            <WishList v-if="isDisplay"></WishList>
            <div class="backBasket" v-if="$route.query.refere === 'basket'">
                <router-link class="backBasket-link pointer" tag="span" :to="'/basket/basket-list-items/' + urlReferrer.params.id">
                    <i class="fas fa-angle-double-left fa-1x"></i> {{ $t("basket.back") }}
                </router-link>
            </div>
            <section id="produit" class="flexContainer fd-c full" v-if="product !== 'empty'">
                <p @click="goPrev()" class="back pointer"><img src="../../assets/back.png" width="21" alt /> {{ $t("contentPage.backToSearch") }}</p>
                <section id="produitWrapper">
                    <div class="content-product rel">
                        <div class="row">
                            <loader :loading="loading"></loader>
                            <div class="col-lg-3 col-md-3">
                                <ComponentPreview :component="product" :imageId="selectedImageId" @click="openZoomer"></ComponentPreview>
                                <!-- TODO: image caroussel -->
                                <div class="smallImgContainer">
                                    <div
                                        v-for="image in orderedFiguresAdvances"
                                        :key="image.id"
                                        id="smallPic"
                                        class="figuresList"
                                        @click="selectedImageId = image.id"
                                    >
                                        <img
                                            :src="getImgPathFig(image.small, 'small')"
                                            :id="'smallPhoto' + image.small"
                                            class="otherPhoto pointer"
                                            alt
                                        />
                                    </div>
                                </div>
                                <div class="configurationLog" v-if="product.config != null">
                                    <p v-if="product.createConfigAt">
                                        {{
                                            $t("component.moduleConfifured")
                                                .replace("{user}", fullNameFormat(product.createConfigBy))
                                                .replace("{date}", product.createConfigAt)
                                        }}
                                    </p>
                                    <p v-if="product.modifiedConfigBy">
                                        {{
                                            $t("component.moduleLastModified")
                                                .replace("{user}", fullNameFormat(product.modifiedConfigBy))
                                                .replace("{date}", product.modifiedConfigAt)
                                        }}
                                    </p>
                                </div>

                                <div class="flexContainer actions">
                                    <router-link
                                        v-if="product.type.name === 'module' && configuratorAble() && hasAccessBothAdmin()"
                                        :to="{ name: 'Configurator' }"
                                        exact
                                        class="btn pointer uppercase configurateur"
                                        tag="button"
                                        >{{ $t("component.configurator") }}</router-link
                                    >
                                    <router-link
                                        v-if="showImageEditor"
                                        class="btn pointer uppercase"
                                        tag="button"
                                        :to="{ name: 'ProductImgEditor' }"
                                        exact
                                        >{{ $t("component.imgEditor") }}</router-link
                                    >
                                    <router-link
                                        v-if="hasEditorRoute && hasAccessBothAdmin()"
                                        class="btn pointer uppercase"
                                        :to="editorRoute"
                                        exact
                                        tag="button"
                                        >{{ $trad.configurator.label }}</router-link
                                    >
                                </div>
                            </div>
                            <div class="col-lg-6 col-md-6">
                                <div id="titleProduit" class="flexContainer jc-sb">
                                    <div class="bloc-title">
                                        <span class="published" v-if="product.is_published === false">[{{ $t("component.notPublished") }}]</span>
                                        <hr class="clear" />
                                        <span class="uppercase bold titleComponent" v-if="product.terms.hasOwnProperty('name')">
                                            {{
                                                (product.type.name === "fascia" && product.config
                                                    ? `${product.config.width} x ${product.config.height} `
                                                    : "") + getTranslate(product.terms.name)
                                            }}
                                        </span>
                                        <div class="uppercase titleComponent" v-if="product && product.standDesign">
                                            {{ product.standDesign.name }}
                                        </div>
                                        <hr class="clear" />
                                        <div
                                            class="ff-light uppercase statusTitle blocBtn"
                                            v-if="product.status"
                                            :style="{ backgroundColor: getStatusColor(product.status.name) }"
                                        >
                                            {{ getTranslate(product.status.terms.name) }}
                                        </div>
                                        <div class="ff-light uppercase blocBtn" v-if="product.campaigns !== null && product.campaigns.launch">
                                            {{ $t("product.launch") }}: {{ product.campaigns.launch.name }}
                                            <span v-if="product.campaigns.discontinued.name">
                                                <br />
                                                {{ $t("product.discontinued") }}: {{ product.campaigns.discontinued.name }}
                                            </span>
                                        </div>
                                        <div
                                            v-if="
                                                hasAccessValidate(`${product.type.name}_manager`, [
                                                    APPLICATION.FORECAST_ID,
                                                    APPLICATION.CATALOG_FORECAST_ID
                                                ])
                                            "
                                        >
                                            <span class="publish txtCenter">{{ $t("product.publish") }}</span>
                                            <label class="switch flexContainer" @change="publish()">
                                                <div class="flexContainer">
                                                    <input id="publishedButton" v-if="product.is_published === false" type="checkbox" />
                                                    <input id="publishedButton" v-else type="checkbox" checked /> <span class="slider round"></span>
                                                </div>
                                            </label>
                                        </div>
                                        <br />
                                    </div>
                                    <div class="export-pdf-product">
                                        <h3 class="ff-medium rel flexContainer jc-sb btnExportPDF">
                                            <!-- TODO @boris liste des types de composants qui ont accès a ce btn -->
                                            <span
                                                @click="openPdf()"
                                                class="mobileNot exportPDFCat iLineBlock"
                                                v-if="
                                                    (product.type.name === 'module' || product.type.name === 'product') &&
                                                        product.type.name != 'artwork' &&
                                                        product.type.name != 'accessory' &&
                                                        product.type.name != 'peel-off'
                                                "
                                            >
                                                <ExportPdfSvg></ExportPdfSvg>
                                            </span>
                                            <span @click="addStar(product.id)" :key="product.isStar">
                                                <i class="fa-star fa-2x pointer" :class="product.isStar ? 'fas' : 'far'" :style="starStyle"></i>
                                            </span>
                                            <div class="msgPDFCat" v-if="showpopin">
                                                <div class="arrow"></div>
                                                {{ $t("product.errorCompagn") }}
                                            </div>
                                        </h3>
                                    </div>
                                </div>

                                <div v-if="infosDisplay" id="infoProduitContent" class="infoProduitContent">
                                    <ul class="uppercase listNone flexContainer jc-sa m-fd-c t-fd-c txtCenter">
                                        <li class="tab active bold">{{ $t("product.articleInfos") }}</li>
                                    </ul>
                                    <table class="table product-table table-striped table-sm table-borderless">
                                        <tbody>
                                            <tr v-if="hasAccessRead('plano_builder')">
                                                <td>{{ $t("component.typeComponentForPlano") }}</td>
                                                <td>{{ product.type.terms.name[$t("trad")] }}</td>
                                            </tr>
                                            <tr v-for="(n, key) in categoryHierarchy" :key="`categoriesArb_${key}`">
                                                <td class="ff-medium m-w-mid vMid">{{ $t("component.categories") }} {{ key + 1 }}</td>
                                                <td class="m-w-mid vMid">{{ n.map(element => element.name[$t("trad")]).join(" / ") }}</td>
                                            </tr>
                                            <tr v-for="(info, key) in product.infosArticle" v-if="info.componentProperty.value !== ''" :key="info.id">
                                                <td
                                                    class="ff-medium m-w-mid vMid"
                                                    v-if="key.toLowerCase() != 'categories' && product.type.name != 'artwork'"
                                                >
                                                    {{ info.componentProperty.terms.name[$t("trad")]["value"] }}
                                                </td>
                                                <td class="m-w-mid vMid" v-if="key.toLowerCase() != 'categories'">
                                                    {{ info.componentProperty.value }}
                                                </td>
                                            </tr>
                                            <tr v-if="cogsProperty && cogsProperty.value !== ''">
                                                <td class="ff-medium m-w-mid vMid" v-if="product.type.name !== 'artwork'">
                                                    {{ cogsProperty.terms.name[$t("trad")]["value"] }}
                                                </td>
                                                <td class="m-w-mid vMid">
                                                    {{ parseFloat(cogsProperty.value).toFixed(2) }} {{ getBrand.currency.symbol }}
                                                </td>
                                            </tr>
                                            <tr v-if="hasAccessRead('plano_builder')">
                                                <td class="ff-medium m-w-mid vMid">{{ $t("component.nickname") }}</td>
                                                <td
                                                    v-if="
                                                        product.terms.hasOwnProperty('nickname') && product.terms.nickname.hasOwnProperty($t('trad'))
                                                    "
                                                >
                                                    {{ product.terms.nickname[$t("trad")]["value"] }}
                                                </td>
                                                <td v-else>{{ product.nickname }}</td>
                                            </tr>

                                            <tr v-if="product.comment !== null">
                                                <td>{{ $t("catalogue.comment") }}</td>
                                                <td>{{ product.comment }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <br />
                                    <div class="infoProduitContent">
                                        <ul class="uppercase listNone flexContainer jc-sa m-fd-c t-fd-c txtCenter">
                                            <li class="tab active bold">{{ $t("product.zoneCampaignInfos") }}</li>
                                        </ul>
                                        <table class="table table-striped table-sm table-borderless">
                                            <thead>
                                                <tr>
                                                    <th align="left" scope="col">ZONES</th>
                                                    <th align="left" scope="col">{{ $t("campaign.from") }}</th>
                                                    <th align="left" scope="col">{{ $t("campaign.to") }}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="zone in orderedZones" :key="zone.id">
                                                    <td class="uppercase">
                                                        {{ zone.zone.name }} <span v-if="isDisabledZone(zone.zone.id)"><i>(Deleted)</i></span>
                                                    </td>
                                                    <td v-if="zone.campaign !== null">{{ zone.campaign.name }}</td>
                                                    <td>
                                                        <span v-if="zone.discontinuedCampaign">{{ zone.discontinuedCampaign.name }}</span>
                                                        <span v-else> {{ $t("campaign.notDiscontinued") }}</span>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <button
                                        id="delete"
                                        class="btn uppercase pointer ff-light btnDelete fleft"
                                        @click="deleteItem()"
                                        v-if="canDeleteComponent"
                                    >
                                        {{ $t("common.delete") }}
                                    </button>

                                    <router-link
                                        class="btn uppercase pointer ff-light btnEdit fleft"
                                        :to="`/components/${product.id}/edit`"
                                        v-if="canUpdateComponent"
                                    >
                                        {{ $t("common.edit") }}</router-link
                                    >
                                </div>
                            </div>
                            <div class="col-lg-3 col-md-3">
                                <h3
                                    v-if="
                                        product.price != null && displayRealPrice(product.price, product.priceShown, true) && product.price.currency
                                    "
                                >
                                    {{
                                        $t("basket.shippingPrice").replace(
                                            "{price}",
                                            currencyCustomPipe(product.price.value, "en-US", product.price.currency.shortName)
                                        )
                                    }}
                                </h3>
                                <AddToBasket
                                    v-if="
                                        product.price != null &&
                                        product.type.name !== 'product' && // is basket
                                            hasAccessRead('orders_manager') &&
                                            (product.eStoreType != 1 || (product.eStoreType == 2 && hasAccessBothAdmin()))
                                    "
                                ></AddToBasket>
                                <br />
                                <div
                                    class="pointer"
                                    v-if="product.type.name === 'module' || product.type.name === 'product'"
                                    style="background-color: rgba(52, 52, 52, 0.45); height: 50px;"
                                    @click.prevent.stop="addWishList(product)"
                                >
                                    <img src="../../../static/img/pdf_icon_2.svg" alt height="35" style="padding-left:12px;margin-top:7px;" />
                                    <p class="fright addBook" style="padding-right: 28px;margin-top: 16px;color:#fff;">ADD TO A PDF BOOK</p>
                                </div>
                                <ForecastItemManager v-if="hasAccessForecastItemManager" :item="product" />
                            </div>
                        </div>
                        <br />
                    </div>
                    <div><ItemForecast v-if="hasAccessForecastItemSummary" :itemId="product.id"></ItemForecast></div>
                </section>
                <teinte v-if="product.type.name === 'product'"></teinte> <br />
                <Related></Related>
                <br />
                <TicketStrip v-if="product.type.name === 'module'"></TicketStrip>
                <br />
                <div class="createBy">
                    <span class="fright">
                        {{ $t("planobuilder.by") }} {{ product.createdUser.firstname }} {{ product.createdUser.lastname }}
                        {{ $t("planobuilder.on") }} {{ product.createdUser.dateCreated }}
                        <span v-if="product.modifiedUser !== null">
                            - {{ $t("planobuilder.modifiedBy") }} {{ product.modifiedUser.firstname }} {{ product.modifiedUser.lastname }}
                            {{ $t("planobuilder.on") }} {{ product.modifiedUser.modifiedDate }}
                        </span>
                    </span>
                </div>
            </section>
            <section class="flexContainer fd-c full" v-if="product === 'empty'">
                <div class="flexContainer noComponentDiv">
                    <h2 class="noComponent txtCenter uppercase">{{ $t("product.noComponent") }}</h2>
                </div>
            </section>
            <Modal :action="dataAction"></Modal>
        </main>
    </div>
</template>
<script>
import Teinte from "./Teinte.vue";
import { mapGetters, mapActions, mapState } from "vuex";
import Globals from "../globals.js";
import "whatwg-fetch";
import VueBase64FileUpload from "vue-base64-file-upload";
import Related from "./Related.vue";
import httpService from "../service";
import TicketStrip from "./TicketStrip";
import WishList from "../wishlist/WishList.vue";
import AddToBasket from "../modal/AddToBasket";
import Modal from "./modal/Modal";
import loader from "../loader/loader";
import ExportPdfSvg from "./ExportPdfSvg";
import { BFormGroup } from "bootstrap-vue";
import TryLoad from "@/mixins/TryLoadMixin";
import { ERROR_PAGE_NAME } from "@/router";
import ComponentPreview from "@/catalog/component-preview";
import { centerToBottomLeft } from "@/catalog/caddy-utils";
import cacheService from "@/services/cache";
import componentService from "@/services/component";
import ForecastItemManager from "@/components/forecasts/elements/catalogue/ItemDetail";
import ItemForecast from "@/components/forecasts/elements/catalogue/ItemQuantities";
import { PROFILES } from "@/plugins/AccessUserPlugin";
import { APPLICATION } from "@/components/admin/brand/constant";

export default {
    components: {
        ItemForecast,
        ForecastItemManager,
        ComponentPreview,
        BFormGroup,
        teinte: Teinte,
        VueBase64FileUpload,
        Related,
        TicketStrip,
        WishList,
        AddToBasket,
        Modal,
        loader,
        ExportPdfSvg
    },
    data: () => ({
        APPLICATION,
        urlReferrer: {},
        dataAction: "",
        colors: cacheService.getBrandColors(),
        selectedImageId: undefined,
        selectedForecastId: undefined,
        showpopin: false,
        zoneSelected: null,
        hasDisplaySelectZone: false,
        loading: false,
        infosDisplay: true,
        descDisplay: false,
        product: undefined,
        detail: [],
        idDetail: null,
        color: "",
        userString: "",
        brand: false,
        properties: {},
        categories: {},
        allSystemTypes: [],
        description: "",
        zoneName: [],
        zones: [],
        modeWishList: "add",
        cogsProperty: null
    }),
    mixins: [TryLoad],
    watch: {
        "$route.params.id"(newId, oldId) {
            this.loadComponent(newId);
            this.$store.dispatch("items/getDetails", { id: this.$route.params.id });
            this.idDetail = this.$route.params.id;
        }
    },
    methods: {
        ...mapActions("forecast", { populateAdminBrandZones: "populateAdminBrandZones" }),
        ...mapActions("forecast", { isDisabledZone: "isDisabledZone" }),
        ...mapActions({
            toAddList: "catalog/wishlist/toAddList",
            setDisplay: "catalog/wishlist/setDisplay",
            setModeWishList: "catalog/wishlist/setMode"
        }),
        ...mapActions("module/status", ["getListStatus"]),
        ...mapActions("items", ["getComponent"]),
        addStar(id) {
            Globals.addCheckedStar(!this.product.isStar, id);
            this.product.isStar = !this.product.isStar;
        },
        diamHasRights() {
            return this.hasDiamAccess("price_manager", ...this.AccessUser.CONTRIBUTE);
        },
        async loadComponent() {
            this.loading = true;
            this.userString = this.currentUser;
            this.idDetail = this.$route.params.id;
            this.$dialog.globalOptions.cancelText = "Cancel";
            this.$dialog.globalOptions.okText = "Confirm Delete";
            // const response = await this.$store.dispatch("items/getDetails", { id: this.$route.params.id });
            try {
                this.product = await this.getComponent(this.$route.params.id);
                this.product.price = this.product.prices.find(p => p.zone.id === cacheService.getCurrentZoneId());
            } catch (e) {
                if (e.code) {
                    this.product = "empty";
                    if (e.code === 404) {
                        this.product = "empty";
                        this.dialogError(this.$t("product.noComponent"), this.$t("error.404.errorText"));
                        return;
                    } else {
                        this.dialogError(`${e.code} :  ${e.message}`, this.$t("common.error"));
                    }
                } else {
                    this.dialogError(e.message, this.$t("common.error"));
                }
            } finally {
                this.loading = false;
            }
            this.$store.dispatch("items/findRelatedTicketsStrip", { id: this.$route.params.id }).then(() => {});
        },
        async openPdf() {
            let currentCampaignId = cacheService.getCurrentCampaignId();

            const res = await this.tryLoad(() => componentService.exportPdf(this.idDetail));

            if (currentCampaignId === "0" || currentCampaignId === "") {
                this.showpopin = true;
            } else {
                this.showpopin = false;
            }
            let url = Globals.getBaseUrl() + res;
            window.open(url, "_blank");
        },

        addWishList(component) {
            this.setModeWishList("add");
            let comp = {
                id: component.id,
                images: component.figures_advanced,
                name: component.terms.name,
                type: component.type
            };
            this.toAddList(comp);
            this.setDisplay(true);
        },

        fullNameFormat(objName) {
            return objName ? objName.firstname + " " + objName.lastname : "";
        },
        publish() {
            let self = this;
            if (document.getElementById("publishedButton").checked === true) {
                let toPublish = {
                    visible: 1,
                    toValidate: 0,
                    isValidate: 1
                };
                this.loading = !this.loading;
                httpService.put("/components/" + this.$route.params.id + "/publish", JSON.stringify(toPublish)).then(function(response) {
                    self.loading = false;
                    location.reload();
                });
            } else {
                let toPublish = {
                    visible: 0,
                    toValidate: 0,
                    isValidate: 0
                };
                this.loading = !this.loading;
                httpService.put("/components/" + this.$route.params.id + "/publish", JSON.stringify(toPublish)).then(function(response) {
                    self.loading = false;
                    location.reload();
                });
            }
        },
        configuratorAble() {
            let svg = this._.find(this.product.figures_advanced, function(o) {
                return o.id_type_file === 6;
            });
            return typeof svg !== "undefined";
        },
        openZoomer() {
            // TODO: fix zoomer
            this.dataAction = {
                action: "zoomer",
                // data: dataImg,
                dataImg: this.orderedFiguresAdvances,
                order: this.selectedImage && this.selectedImage.order,
                idImg: this.selectedImageId
            };
            this.$root.$emit("bv::show::modal", "defaultModal");
        },
        getImgPathFig(imgPath, format) {
            return Globals.getBaseUrl() + imgPath;
        },
        goPrev() {
            this.$router.go(-1);
        },
        deleteItem() {
            this.$swal({
                title: this.$t("product.deleteModal.confirmTitle"),
                text: this.$t("product.deleteModal.warningText"),
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#41b4e8",
                confirmButtonText: this.$t("product.deleteModal.confirmDelete"),
                closeOnConfirm: true
            }).then(result => {
                if (result === true) {
                    this.loading = true;
                    httpService.delete("/components/" + this.getDetails(this.$route.params.id).id).then(() => {
                        this.$router.push({ name: "Dashboard" });
                    });
                } else {
                }
            });
            this.loading = false;
        },
        hasAccessUpdateToType(apps = [APPLICATION.FORECAST_ID], ...types) {
            if (!types) return false;
            for (const type of types) {
                if (this.product && this.product.type && this.product.type.name === type && this.hasAccessUpdate(`${type}_manager`, apps))
                    return true;
            }
            return false;
        },
        hasRoute(route) {
            const res = this.$router.resolve(route);
            return res && res.resolved && res.resolved.name !== ERROR_PAGE_NAME;
        },
        isDisabledZone(zoneId) {
            const brandZone = this.brandZones.find(bz => bz.zone.id === zoneId);
            if (!brandZone) {
                return true;
            }
            return !brandZone.active;
        }
    },
    computed: {
        ...mapGetters("forecast", { brandZones: "getAdminBrandZones" }),
        selectedImage() {
            return this._.find(this.product.figures_advanced, o => {
                return o.id === this.selectedImageId;
            });
        },
        orderedFiguresAdvances() {
            return _.orderBy(this.product.figures_advanced, "order");
        },
        orderedZones() {
            return _.orderBy(this.product.zones, "zone.name");
        },
        caddyConfig() {
            return centerToBottomLeft(this.product.config);
        },
        categoryHierarchy() {
            let cats = [];
            for (let i = 0; i < this.product.categories.length; i++) {
                cats[i] = [];
                let category = this.product.categories[i].category;
                while (category) {
                    cats[i].push(category.terms);
                    category = category.parent;
                }
                cats[i] = cats[i].reverse();
            }
            return cats;
        },
        ...mapGetters({
            getDetails: "items/getDetails",
            getBrand: "brand/getBrand",
            isDisplay: "catalog/wishlist/isDisplay"
        }),
        ...mapGetters("currentUser", { currentUser: "currentUser" }),
        ...mapGetters("module/status", ["getStatusColor"]),
        ...mapState("module/status", ["listStatus"]),
        starStyle() {
            return this.product.isStar ? { color: this.colors.color4 } : "";
        },
        canUpdateComponent() {
            return this.hasAccessUpdate(`${this.product.type.name}_manager`, [APPLICATION.FORECAST_ID, APPLICATION.CATALOG_FORECAST_ID]);
        },
        canDeleteComponent() {
            return this.hasAccessDelete(`${this.product.type.name}_manager`, [APPLICATION.FORECAST_ID, APPLICATION.CATALOG_FORECAST_ID]);
        },
        showImageEditor() {
            return (
                ((this.product.type.name === "module" || this.product.type.name === "product" || this.product.type.name === "accessory") &&
                    this.hasAccessBothAdmin()) ||
                // frames don't have a realist image
                this.hasAccessUpdateToType(
                    [APPLICATION.FORECAST_ID, APPLICATION.CATALOG_FORECAST_ID],
                    "product",
                    "module",
                    "artwork",
                    "fascia",
                    "structure",
                    "shelf",
                    "ticket_strip",
                    "display",
                    "accessory"
                )
            );
        },
        editorRoute() {
            return `/${this.product.type.name}/${this.$route.params.id}/editor`;
        },
        hasEditorRoute() {
            return this.hasRoute(this.editorRoute);
        },
        hasAccessForecastItemManager() {
            return (
                this.hasAccessByProfile(PROFILES.FORECAST_MANAGER, APPLICATION.FORECAST_ID) ||
                this.hasAccessByProfile(PROFILES.FORECAST_MANAGER, APPLICATION.CATALOG_FORECAST_ID)
            );
        },
        hasAccessForecastItemSummary() {
            return (
                this.hasAccessByProfile(PROFILES.FORECAST_MANAGER, APPLICATION.FORECAST_ID) ||
                this.hasAccessByProfile(PROFILES.ZONES_SUPERVISOR, APPLICATION.FORECAST_ID) ||
                this.hasAccessByProfile(PROFILES.FORECAST_MANAGER, APPLICATION.CATALOG_FORECAST_ID) ||
                this.hasAccessByProfile(PROFILES.ZONES_SUPERVISOR, APPLICATION.CATALOG_FORECAST_ID)
            );
        }
    },
    async created() {
        await this.loadComponent();
        this.$dialog.globalOptions.cancelText = "Cancel";
        this.$dialog.globalOptions.okText = "Confirm Delete";

        await this.getListStatus();
        httpService.get("/components/categories").then(response => {
            this.categories = response.categories;
        });
        httpService.get("/system/types").then(response => {
            this.allSystemTypes = response;
        });
        httpService.get("/components/" + this.$route.params.id + "/cogs").then(response => {
            this.cogsProperty = response;
        });
        await this.populateAdminBrandZones({ reload: true });
    }
};
</script>

<style lang="scss" scoped>
@import "../../assets/css/themes.scss";

td,
th {
    padding: 10px;
}
th[scope="col"] {
    background-color: #696969;
    color: #fff;
}

.backBasket {
    display: inline-block;
    padding: 10px 0 5px 0;
    &-link {
        text-transform: none;
        padding: 5px 20px 5px 10px;
        color: white;
        font-size: 12px;
        background-color: $color4;
        svg {
            margin-right: 5px;
        }
    }
}

#titleProduit {
    display: inline-block;
    width: calc(100% - 60px);
    @media only screen and (max-width: 767px) {
        width: 100%;
        position: relative;
    }
    .bloc-title {
        display: inline-block;
        width: calc(100% - 117px);
        @media only screen and (max-width: 767px) {
            width: 100%;
            margin-top: 20px;
        }
    }
    .blocBtn {
        display: inline-block;
        padding: 10px 15px;
        margin: 10px 0px;
        background-color: #757575;
        color: #fff;
        @media only screen and (max-width: 767px) {
            width: 100%;
        }
    }
    .export-pdf-product {
        float: right;
        @media only screen and (max-width: 767px) {
            position: absolute;
            top: -5px;
            right: -5px;
        }
    }
}

.btnExportPDF {
    & .exportPDFCat {
        cursor: pointer;
        width: 25px;
        margin: 0px 10px;
        vertical-align: middle;
    }
    & .msgPDFCat {
        background: rgba(0, 0, 0, 0.2);
        position: absolute;
        top: 35px;
        display: block;
        width: 100%;
        padding: 5px 10px;
        font-size: 12px;
        color: #343434;
        & .arrow {
            position: absolute;
            width: 0;
            height: 0;
            top: -5px;
            border-left: 5px solid transparent;
            border-right: 5px solid transparent;
            border-bottom: 5px solid rgba(0, 0, 0, 0.2);
        }
    }
}

.smallImgContainer {
    height: 107px;
    margin: 10px 0px;
    overflow: auto;
    white-space: nowrap;
    @extend %primary-background;
    @media only screen and (max-width: 767px) {
        height: 85px;
    }
}
.addBook {
    font-family: "Oswald", Sans-Serif;
}

.table td {
    border-top: none;
}

.createBy {
    padding: 5px;
}

.configurationLog {
    margin: 10px 0px;
    p {
        margin: 2px 0px;
        font-size: 10px;
    }
}

.configurateur {
    margin-right: 10px;
}

.publish {
    margin: auto;
    padding-right: 5px;
    font-size: 17px;
}

.switch {
    position: absolute;
    display: inline-block;
    width: 48px;
    height: 22px;
}

.switch input {
    display: none;
}

.slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    -webkit-transition: 0.4s;
    transition: 0.4s;
}

.slider:before {
    position: absolute;
    content: "";
    height: 15px;
    width: 15px;
    left: 4px;
    bottom: 4px;
    background-color: white;
    -webkit-transition: 0.4s;
    transition: 0.4s;
}

input:checked + .slider {
    background-color: #727a96;
}

input:focus + .slider {
    box-shadow: 0 0 1px #727a96;
}

input:checked + .slider:before {
    -webkit-transform: translateX(26px);
    -ms-transform: translateX(26px);
    transform: translateX(26px);
}

/* Rounded sliders */
.slider.round {
    border-radius: 34px;
}

.slider.round:before {
    border-radius: 50%;
}

.published {
    font-size: 11px;
    border: 1px solid #ff7b15;
    background-color: #ff7b15;
    color: white;
}

.titleComponent {
    font-family: "Oswald", Sans-Serif;
    font-size: 35px;
    @media only screen and (max-width: 767px) {
        width: calc(100% - 30px);
        display: block;
    }
}

.noComponentDiv {
    top: 50%;
    width: 100%;
    @extend %primary-text;
}

.noComponent {
    font-family: Roboto;
    font-size: 20px;
    margin: auto;
}

.otherPhoto {
    padding-top: 2px;
    height: 100%;
}

div.vue-base64-file-upload > img {
    width: 200px;
    margin: 4px;
    float: left;
}

#produit {
    @extend %primary-bloc;
    @extend %primary-text;
    margin-top: 10px;
    background-color: white;
    border-radius: 3px;
    .back {
        padding: 10px 30px;
        font-size: 1.4rem;
        width: 145px;
        img {
            position: relative;
            bottom: 2px;
            margin-right: 5px;
        }
        a {
            text-decoration: none;
            color: black;
        }
    }
    #produitWrapper {
        padding: 10px 30px 0px 30px;
        .produitView {
            padding-bottom: 40px;
            .imgProduit {
                padding-right: 1rem;
                .fileTypeName {
                    padding-top: 15px;
                }
                .addPhoto {
                    font-size: 14px;
                    margin-bottom: 15px;
                    select {
                        margin-left: 10px;
                    }
                }
                h2 {
                    .btn {
                        right: 0;
                        top: 0;
                    }
                }
                .thumbnail {
                    margin-top: 6%;
                    .cross {
                        width: 20px;
                        height: 20px;
                        margin-left: 5px;
                        margin-right: 0px;
                    }
                }
            }
            .infoProduit {
                padding-left: 1rem;
                h3 {
                    margin-bottom: 0.3rem;
                    margin-top: 0;
                    .btn {
                        width: 135px;
                        min-width: 110px;
                        text-decoration: none;
                        color: #343434;
                        text-align: center;
                        line-height: 25px;
                        margin-left: 20px;
                        &:hover {
                            color: #343434;
                        }
                    }
                }
                h4 {
                    margin-top: 0;
                    font-size: 1.6rem;
                }
                .description {
                    font-size: 1.4rem;
                }
                .infoProduitContent {
                    @extend %primary-text;

                    margin-top: 40px;
                    ul {
                        padding: 0;
                        li {
                            border-bottom: 2px solid #343434;
                            color: #343434;
                            font-weight: 500;
                            font-size: 1.6rem;
                            width: 100%;
                            padding-bottom: 0.4rem;
                        }
                    }
                }
                .publicPrice {
                    font-size: 1.2rem;
                    color: #95989a;
                }
            }
        }
    }
    h3 {
        font-size: 1.8rem;
    }
    .slide-fade-enter-active {
        transition: all 0.3s ease;
    }
    .slide-fade-leave-active {
        transition: all 0.2s cubic-bezier(1, 0.5, 0.5, 1);
    }
    .slide-fade-enter,
    .slide-fade-leave-to {
        transform: translateY(10px);
        opacity: 0;
    }
    #relatedItems {
        max-width: 300px;
        margin-left: 30px;
        margin-bottom: 30px;
    }
}

.btnEdit {
    height: 31px;
    margin-top: 15px;
    text-decoration: none;
}

.btnDelete {
    height: 31px;
    margin-top: 15px;
    margin-right: 10px;
}

.figuresList {
    padding-left: 15px;
    display: inline-block;
    height: 100%;
}

.table-striped {
    tbody {
        tr:nth-of-type(odd) {
            @extend %second-background;
        }
    }
}

@media only screen and (max-width: 767px) {
    #produit {
        #produitWrapper {
            padding-left: 20px;
            padding-right: 20px;
            .produitView {
                padding-bottom: 5px;
                .imgProduit,
                .infoProduit {
                    padding: 0px;
                    width: 100%;
                }
                .imgProduit {
                    margin-bottom: 1.5rem;
                }
                .infoProduit {
                    #infoProduitContent {
                        ul {
                            padding: 0;
                            li {
                                font-size: 1.6rem;
                                width: 100%;
                                padding-bottom: 0.4rem;
                                border-bottom: 2px solid #343434;
                                font-weight: 500;
                                &.tab {
                                    list-style: none;
                                    margin-bottom: 20px;
                                }
                            }
                            .slideContent {
                                border-right: 1px solid #eee;
                                border-left: 1px solid #eee;
                                p {
                                    font-size: 1.4rem;
                                }
                                .ff-bold {
                                    margin-top: 10px;
                                    margin-bottom: 5px;
                                }
                                .ff-light {
                                    margin-top: 0;
                                }
                            }
                            p {
                                margin-top: 0px;
                            }
                            .publicPrice {
                                margin-top: 15px;
                            }
                        }
                    }
                }
            }
        }
    }
}

@media only screen and (min-width: 768px) and (max-width: 1024px) {
    #produit {
        margin-top: 25px;
        display: block;
        #produitWrapper {
            .produitView {
                .infoProduit {
                    #infoProduitContent {
                        ul {
                            display: block;
                        }
                    }
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// Component.vue?3d8e2e68